// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file caisse/v1/caisse.proto (package caisse.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { AgencyInfo } from "../../agency/v1/agency_pb";
import { file_agency_v1_agency } from "../../agency/v1/agency_pb";
import type { Direction, PageRequest, PageResponse } from "../../tsam/v1/page_pb";
import { file_tsam_v1_page } from "../../tsam/v1/page_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file caisse/v1/caisse.proto.
 */
export const file_caisse_v1_caisse: GenFile = /*@__PURE__*/
  fileDesc("ChZjYWlzc2UvdjEvY2Fpc3NlLnByb3RvEgljYWlzc2UudjEiGAoKR2V0UmVxdWVzdBIKCgJpZBgBIAEoBSIwCgtHZXRSZXNwb25zZRIhCgZjYWlzc2UYASABKAsyES5jYWlzc2UudjEuQ2Fpc3NlIqgCCg1VcGRhdGVSZXF1ZXN0EgoKAmlkGAEgASgFEhEKCWFnZW5jeV9pZBgCIAEoBRImCh50cmFpbl9zdGF0aW9uX3NlYXJjaF9yYWRpdXNfa20YAyABKAUSIAoYYWlycG9ydF9zZWFyY2hfcmFkaXVzX2ttGAQgASgFEiwKJGFzc2lzdGVkX3RyYWluX2FnZW5jeV9mZWVzX2V1cl9jZW50cxgFIAEoBRIsCiRhc3Npc3RlZF9wbGFuZV9hZ2VuY3lfZmVlc19ldXJfY2VudHMYBiABKAUSLQogYXNzaXN0ZWRfYWdlbmN5X2ZlZXNfdmF0X3BlcmNlbnQYByABKAVIAIgBAUIjCiFfYXNzaXN0ZWRfYWdlbmN5X2ZlZXNfdmF0X3BlcmNlbnQiMwoOVXBkYXRlUmVzcG9uc2USIQoGY2Fpc3NlGAEgASgLMhEuY2Fpc3NlLnYxLkNhaXNzZSKLBAoOT25ib2FyZFJlcXVlc3QSCgoCaWQYASABKAUSEQoJYWdlbmN5X2lkGAIgASgFEiYKHnRyYWluX3N0YXRpb25fc2VhcmNoX3JhZGl1c19rbRgDIAEoBRIgChhhaXJwb3J0X3NlYXJjaF9yYWRpdXNfa20YBCABKAUSNQoVdHJhaW5fbWluX2ZsZXhpYmlsaXR5GAUgASgOMhYuY2Fpc3NlLnYxLkZsZXhpYmlsaXR5EjUKFXBsYW5lX21pbl9mbGV4aWJpbGl0eRgGIAEoDjIWLmNhaXNzZS52MS5GbGV4aWJpbGl0eRIdChV0cmFpbl9tYXhfZmFyZV9hbW91bnQYByABKAUSHQoVcGxhbmVfbWF4X2ZhcmVfYW1vdW50GAggASgFEhkKEXRyYWluX2FnZW5jeV9mZWVzGAkgASgFEhkKEXBsYW5lX2FnZW5jeV9mZWVzGAogASgFEiwKJGFzc2lzdGVkX3RyYWluX2FnZW5jeV9mZWVzX2V1cl9jZW50cxgLIAEoBRIsCiRhc3Npc3RlZF9wbGFuZV9hZ2VuY3lfZmVlc19ldXJfY2VudHMYDCABKAUSLQogYXNzaXN0ZWRfYWdlbmN5X2ZlZXNfdmF0X3BlcmNlbnQYDSABKAVIAIgBAUIjCiFfYXNzaXN0ZWRfYWdlbmN5X2ZlZXNfdmF0X3BlcmNlbnQiNAoPT25ib2FyZFJlc3BvbnNlEiEKBmNhaXNzZRgBIAEoCzIRLmNhaXNzZS52MS5DYWlzc2UiFwoVTGlzdElkZW50aXRpZXNSZXF1ZXN0IkcKFkxpc3RJZGVudGl0aWVzUmVzcG9uc2USLQoKaWRlbnRpdGllcxgBIAMoCzIZLmNhaXNzZS52MS5DYWlzc2VJZGVudGl0eSIqCg5DYWlzc2VJZGVudGl0eRIKCgJpZBgBIAEoBRIMCgRuYW1lGAIgASgJIlcKC0xpc3RSZXF1ZXN0EiIKBHBhZ2UYASABKAsyFC50c2FtLnYxLlBhZ2VSZXF1ZXN0EiQKBHNvcnQYAiABKAsyFi5jYWlzc2UudjEuU29ydFJlcXVlc3QiVQoLU29ydFJlcXVlc3QSHwoFZmllbGQYASABKA4yEC5jYWlzc2UudjEuRmllbGQSJQoJZGlyZWN0aW9uGAIgASgOMhIudHNhbS52MS5EaXJlY3Rpb24iVwoMTGlzdFJlc3BvbnNlEiIKB2NhaXNzZXMYASADKAsyES5jYWlzc2UudjEuQ2Fpc3NlEiMKBHBhZ2UYAiABKAsyFS50c2FtLnYxLlBhZ2VSZXNwb25zZSLABAoGQ2Fpc3NlEgoKAmlkGAEgASgFEgwKBG5hbWUYAiABKAkSEQoJYWdlbmN5X2lkGAMgASgFEhMKC2FnZW5jeV9uYW1lGAQgASgJEiYKHnRyYWluX3N0YXRpb25fc2VhcmNoX3JhZGl1c19rbRgFIAEoBRIgChhhaXJwb3J0X3NlYXJjaF9yYWRpdXNfa20YBiABKAUSNQoVdHJhaW5fbWluX2ZsZXhpYmlsaXR5GAcgASgOMhYuY2Fpc3NlLnYxLkZsZXhpYmlsaXR5EjUKFXBsYW5lX21pbl9mbGV4aWJpbGl0eRgIIAEoDjIWLmNhaXNzZS52MS5GbGV4aWJpbGl0eRIgChh0cmFpbl9tYXhfZmFyZV9ldXJfY2VudHMYCSABKAUSIAoYcGxhbmVfbWF4X2ZhcmVfZXVyX2NlbnRzGAogASgFEiMKG3RyYWluX2FnZW5jeV9mZWVzX2V1cl9jZW50cxgLIAEoBRIjChtwbGFuZV9hZ2VuY3lfZmVlc19ldXJfY2VudHMYDCABKAUSLAokYXNzaXN0ZWRfdHJhaW5fYWdlbmN5X2ZlZXNfZXVyX2NlbnRzGA0gASgFEiwKJGFzc2lzdGVkX3BsYW5lX2FnZW5jeV9mZWVzX2V1cl9jZW50cxgOIAEoBRItCiBhc3Npc3RlZF9hZ2VuY3lfZmVlc192YXRfcGVyY2VudBgPIAEoBUgAiAEBQiMKIV9hc3Npc3RlZF9hZ2VuY3lfZmVlc192YXRfcGVyY2VudCIiChRHZXRBZ2VuY3lJbmZvUmVxdWVzdBIKCgJpZBgBIAEoBSJgChVHZXRBZ2VuY3lJbmZvUmVzcG9uc2USLAoLYWdlbmN5X2luZm8YASABKAsyFS5hZ2VuY3kudjEuQWdlbmN5SW5mb0gAEg8KBWVycm9yGAIgASgJSABCCAoGcmVzdWx0Kk4KBUZpZWxkEhUKEUZJRUxEX1VOU1BFQ0lGSUVEEAASDAoIRklFTERfSUQQARIOCgpGSUVMRF9OQU1FEAISEAoMRklFTERfQUdFTkNZEAMqeQoLRmxleGliaWxpdHkSGwoXRkxFWElCSUxJVFlfVU5TUEVDSUZJRUQQABIXChNGTEVYSUJJTElUWV9OT19GTEVYEAESGQoVRkxFWElCSUxJVFlfU0VNSV9GTEVYEAISGQoVRkxFWElCSUxJVFlfRlVMTF9GTEVYEAMytgMKDUNhaXNzZVNlcnZpY2USQgoHT25ib2FyZBIZLmNhaXNzZS52MS5PbmJvYXJkUmVxdWVzdBoaLmNhaXNzZS52MS5PbmJvYXJkUmVzcG9uc2UiABI2CgNHZXQSFS5jYWlzc2UudjEuR2V0UmVxdWVzdBoWLmNhaXNzZS52MS5HZXRSZXNwb25zZSIAEjkKBExpc3QSFi5jYWlzc2UudjEuTGlzdFJlcXVlc3QaFy5jYWlzc2UudjEuTGlzdFJlc3BvbnNlIgASVwoOTGlzdElkZW50aXRpZXMSIC5jYWlzc2UudjEuTGlzdElkZW50aXRpZXNSZXF1ZXN0GiEuY2Fpc3NlLnYxLkxpc3RJZGVudGl0aWVzUmVzcG9uc2UiABI/CgZVcGRhdGUSGC5jYWlzc2UudjEuVXBkYXRlUmVxdWVzdBoZLmNhaXNzZS52MS5VcGRhdGVSZXNwb25zZSIAElQKDUdldEFnZW5jeUluZm8SHy5jYWlzc2UudjEuR2V0QWdlbmN5SW5mb1JlcXVlc3QaIC5jYWlzc2UudjEuR2V0QWdlbmN5SW5mb1Jlc3BvbnNlIgBiBnByb3RvMw", [file_agency_v1_agency, file_tsam_v1_page]);

/**
 * @generated from message caisse.v1.GetRequest
 */
export type GetRequest = Message<"caisse.v1.GetRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message caisse.v1.GetRequest.
 * Use `create(GetRequestSchema)` to create a new message.
 */
export const GetRequestSchema: GenMessage<GetRequest> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 0);

/**
 * @generated from message caisse.v1.GetResponse
 */
export type GetResponse = Message<"caisse.v1.GetResponse"> & {
  /**
   * @generated from field: caisse.v1.Caisse caisse = 1;
   */
  caisse?: Caisse;
};

/**
 * Describes the message caisse.v1.GetResponse.
 * Use `create(GetResponseSchema)` to create a new message.
 */
export const GetResponseSchema: GenMessage<GetResponse> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 1);

/**
 * @generated from message caisse.v1.UpdateRequest
 */
export type UpdateRequest = Message<"caisse.v1.UpdateRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 agency_id = 2;
   */
  agencyId: number;

  /**
   * @generated from field: int32 train_station_search_radius_km = 3;
   */
  trainStationSearchRadiusKm: number;

  /**
   * @generated from field: int32 airport_search_radius_km = 4;
   */
  airportSearchRadiusKm: number;

  /**
   * Agency fees billed when an agent books on behalf of a beneficiary.
   * 0 means not configured: the self-service fees apply.
   *
   * @generated from field: int32 assisted_train_agency_fees_eur_cents = 5;
   */
  assistedTrainAgencyFeesEurCents: number;

  /**
   * @generated from field: int32 assisted_plane_agency_fees_eur_cents = 6;
   */
  assistedPlaneAgencyFeesEurCents: number;

  /**
   * @generated from field: optional int32 assisted_agency_fees_vat_percent = 7;
   */
  assistedAgencyFeesVatPercent?: number;
};

/**
 * Describes the message caisse.v1.UpdateRequest.
 * Use `create(UpdateRequestSchema)` to create a new message.
 */
export const UpdateRequestSchema: GenMessage<UpdateRequest> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 2);

/**
 * @generated from message caisse.v1.UpdateResponse
 */
export type UpdateResponse = Message<"caisse.v1.UpdateResponse"> & {
  /**
   * @generated from field: caisse.v1.Caisse caisse = 1;
   */
  caisse?: Caisse;
};

/**
 * Describes the message caisse.v1.UpdateResponse.
 * Use `create(UpdateResponseSchema)` to create a new message.
 */
export const UpdateResponseSchema: GenMessage<UpdateResponse> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 3);

/**
 * @generated from message caisse.v1.OnboardRequest
 */
export type OnboardRequest = Message<"caisse.v1.OnboardRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 agency_id = 2;
   */
  agencyId: number;

  /**
   * @generated from field: int32 train_station_search_radius_km = 3;
   */
  trainStationSearchRadiusKm: number;

  /**
   * @generated from field: int32 airport_search_radius_km = 4;
   */
  airportSearchRadiusKm: number;

  /**
   * @generated from field: caisse.v1.Flexibility train_min_flexibility = 5;
   */
  trainMinFlexibility: Flexibility;

  /**
   * @generated from field: caisse.v1.Flexibility plane_min_flexibility = 6;
   */
  planeMinFlexibility: Flexibility;

  /**
   * @generated from field: int32 train_max_fare_amount = 7;
   */
  trainMaxFareAmount: number;

  /**
   * @generated from field: int32 plane_max_fare_amount = 8;
   */
  planeMaxFareAmount: number;

  /**
   * @generated from field: int32 train_agency_fees = 9;
   */
  trainAgencyFees: number;

  /**
   * @generated from field: int32 plane_agency_fees = 10;
   */
  planeAgencyFees: number;

  /**
   * Agency fees billed when an agent books on behalf of a beneficiary.
   * 0 means not configured: the self-service fees apply.
   *
   * @generated from field: int32 assisted_train_agency_fees_eur_cents = 11;
   */
  assistedTrainAgencyFeesEurCents: number;

  /**
   * @generated from field: int32 assisted_plane_agency_fees_eur_cents = 12;
   */
  assistedPlaneAgencyFeesEurCents: number;

  /**
   * @generated from field: optional int32 assisted_agency_fees_vat_percent = 13;
   */
  assistedAgencyFeesVatPercent?: number;
};

/**
 * Describes the message caisse.v1.OnboardRequest.
 * Use `create(OnboardRequestSchema)` to create a new message.
 */
export const OnboardRequestSchema: GenMessage<OnboardRequest> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 4);

/**
 * @generated from message caisse.v1.OnboardResponse
 */
export type OnboardResponse = Message<"caisse.v1.OnboardResponse"> & {
  /**
   * @generated from field: caisse.v1.Caisse caisse = 1;
   */
  caisse?: Caisse;
};

/**
 * Describes the message caisse.v1.OnboardResponse.
 * Use `create(OnboardResponseSchema)` to create a new message.
 */
export const OnboardResponseSchema: GenMessage<OnboardResponse> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 5);

/**
 * @generated from message caisse.v1.ListIdentitiesRequest
 */
export type ListIdentitiesRequest = Message<"caisse.v1.ListIdentitiesRequest"> & {
};

/**
 * Describes the message caisse.v1.ListIdentitiesRequest.
 * Use `create(ListIdentitiesRequestSchema)` to create a new message.
 */
export const ListIdentitiesRequestSchema: GenMessage<ListIdentitiesRequest> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 6);

/**
 * @generated from message caisse.v1.ListIdentitiesResponse
 */
export type ListIdentitiesResponse = Message<"caisse.v1.ListIdentitiesResponse"> & {
  /**
   * @generated from field: repeated caisse.v1.CaisseIdentity identities = 1;
   */
  identities: CaisseIdentity[];
};

/**
 * Describes the message caisse.v1.ListIdentitiesResponse.
 * Use `create(ListIdentitiesResponseSchema)` to create a new message.
 */
export const ListIdentitiesResponseSchema: GenMessage<ListIdentitiesResponse> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 7);

/**
 * @generated from message caisse.v1.CaisseIdentity
 */
export type CaisseIdentity = Message<"caisse.v1.CaisseIdentity"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message caisse.v1.CaisseIdentity.
 * Use `create(CaisseIdentitySchema)` to create a new message.
 */
export const CaisseIdentitySchema: GenMessage<CaisseIdentity> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 8);

/**
 * @generated from message caisse.v1.ListRequest
 */
export type ListRequest = Message<"caisse.v1.ListRequest"> & {
  /**
   * @generated from field: tsam.v1.PageRequest page = 1;
   */
  page?: PageRequest;

  /**
   * @generated from field: caisse.v1.SortRequest sort = 2;
   */
  sort?: SortRequest;
};

/**
 * Describes the message caisse.v1.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 9);

/**
 * @generated from message caisse.v1.SortRequest
 */
export type SortRequest = Message<"caisse.v1.SortRequest"> & {
  /**
   * @generated from field: caisse.v1.Field field = 1;
   */
  field: Field;

  /**
   * @generated from field: tsam.v1.Direction direction = 2;
   */
  direction: Direction;
};

/**
 * Describes the message caisse.v1.SortRequest.
 * Use `create(SortRequestSchema)` to create a new message.
 */
export const SortRequestSchema: GenMessage<SortRequest> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 10);

/**
 * @generated from message caisse.v1.ListResponse
 */
export type ListResponse = Message<"caisse.v1.ListResponse"> & {
  /**
   * @generated from field: repeated caisse.v1.Caisse caisses = 1;
   */
  caisses: Caisse[];

  /**
   * @generated from field: tsam.v1.PageResponse page = 2;
   */
  page?: PageResponse;
};

/**
 * Describes the message caisse.v1.ListResponse.
 * Use `create(ListResponseSchema)` to create a new message.
 */
export const ListResponseSchema: GenMessage<ListResponse> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 11);

/**
 * @generated from message caisse.v1.Caisse
 */
export type Caisse = Message<"caisse.v1.Caisse"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 agency_id = 3;
   */
  agencyId: number;

  /**
   * @generated from field: string agency_name = 4;
   */
  agencyName: string;

  /**
   * @generated from field: int32 train_station_search_radius_km = 5;
   */
  trainStationSearchRadiusKm: number;

  /**
   * @generated from field: int32 airport_search_radius_km = 6;
   */
  airportSearchRadiusKm: number;

  /**
   * @generated from field: caisse.v1.Flexibility train_min_flexibility = 7;
   */
  trainMinFlexibility: Flexibility;

  /**
   * @generated from field: caisse.v1.Flexibility plane_min_flexibility = 8;
   */
  planeMinFlexibility: Flexibility;

  /**
   * @generated from field: int32 train_max_fare_eur_cents = 9;
   */
  trainMaxFareEurCents: number;

  /**
   * @generated from field: int32 plane_max_fare_eur_cents = 10;
   */
  planeMaxFareEurCents: number;

  /**
   * @generated from field: int32 train_agency_fees_eur_cents = 11;
   */
  trainAgencyFeesEurCents: number;

  /**
   * @generated from field: int32 plane_agency_fees_eur_cents = 12;
   */
  planeAgencyFeesEurCents: number;

  /**
   * Agency fees billed when an agent books on behalf of a beneficiary.
   * 0 means not configured: the self-service fees apply.
   *
   * @generated from field: int32 assisted_train_agency_fees_eur_cents = 13;
   */
  assistedTrainAgencyFeesEurCents: number;

  /**
   * @generated from field: int32 assisted_plane_agency_fees_eur_cents = 14;
   */
  assistedPlaneAgencyFeesEurCents: number;

  /**
   * @generated from field: optional int32 assisted_agency_fees_vat_percent = 15;
   */
  assistedAgencyFeesVatPercent?: number;
};

/**
 * Describes the message caisse.v1.Caisse.
 * Use `create(CaisseSchema)` to create a new message.
 */
export const CaisseSchema: GenMessage<Caisse> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 12);

/**
 * @generated from message caisse.v1.GetAgencyInfoRequest
 */
export type GetAgencyInfoRequest = Message<"caisse.v1.GetAgencyInfoRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message caisse.v1.GetAgencyInfoRequest.
 * Use `create(GetAgencyInfoRequestSchema)` to create a new message.
 */
export const GetAgencyInfoRequestSchema: GenMessage<GetAgencyInfoRequest> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 13);

/**
 * @generated from message caisse.v1.GetAgencyInfoResponse
 */
export type GetAgencyInfoResponse = Message<"caisse.v1.GetAgencyInfoResponse"> & {
  /**
   * @generated from oneof caisse.v1.GetAgencyInfoResponse.result
   */
  result: {
    /**
     * @generated from field: agency.v1.AgencyInfo agency_info = 1;
     */
    value: AgencyInfo;
    case: "agencyInfo";
  } | {
    /**
     * @generated from field: string error = 2;
     */
    value: string;
    case: "error";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message caisse.v1.GetAgencyInfoResponse.
 * Use `create(GetAgencyInfoResponseSchema)` to create a new message.
 */
export const GetAgencyInfoResponseSchema: GenMessage<GetAgencyInfoResponse> = /*@__PURE__*/
  messageDesc(file_caisse_v1_caisse, 14);

/**
 * @generated from enum caisse.v1.Field
 */
export enum Field {
  /**
   * @generated from enum value: FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FIELD_ID = 1;
   */
  ID = 1,

  /**
   * @generated from enum value: FIELD_NAME = 2;
   */
  NAME = 2,

  /**
   * @generated from enum value: FIELD_AGENCY = 3;
   */
  AGENCY = 3,
}

/**
 * Describes the enum caisse.v1.Field.
 */
export const FieldSchema: GenEnum<Field> = /*@__PURE__*/
  enumDesc(file_caisse_v1_caisse, 0);

/**
 * @generated from enum caisse.v1.Flexibility
 */
export enum Flexibility {
  /**
   * @generated from enum value: FLEXIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FLEXIBILITY_NO_FLEX = 1;
   */
  NO_FLEX = 1,

  /**
   * @generated from enum value: FLEXIBILITY_SEMI_FLEX = 2;
   */
  SEMI_FLEX = 2,

  /**
   * @generated from enum value: FLEXIBILITY_FULL_FLEX = 3;
   */
  FULL_FLEX = 3,
}

/**
 * Describes the enum caisse.v1.Flexibility.
 */
export const FlexibilitySchema: GenEnum<Flexibility> = /*@__PURE__*/
  enumDesc(file_caisse_v1_caisse, 1);

/**
 * @generated from service caisse.v1.CaisseService
 */
export const CaisseService: GenService<{
  /**
   * @generated from rpc caisse.v1.CaisseService.Onboard
   */
  onboard: {
    methodKind: "unary";
    input: typeof OnboardRequestSchema;
    output: typeof OnboardResponseSchema;
  },
  /**
   * @generated from rpc caisse.v1.CaisseService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetRequestSchema;
    output: typeof GetResponseSchema;
  },
  /**
   * @generated from rpc caisse.v1.CaisseService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListResponseSchema;
  },
  /**
   * @generated from rpc caisse.v1.CaisseService.ListIdentities
   */
  listIdentities: {
    methodKind: "unary";
    input: typeof ListIdentitiesRequestSchema;
    output: typeof ListIdentitiesResponseSchema;
  },
  /**
   * @generated from rpc caisse.v1.CaisseService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateRequestSchema;
    output: typeof UpdateResponseSchema;
  },
  /**
   * @generated from rpc caisse.v1.CaisseService.GetAgencyInfo
   */
  getAgencyInfo: {
    methodKind: "unary";
    input: typeof GetAgencyInfoRequestSchema;
    output: typeof GetAgencyInfoResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_caisse_v1_caisse, 0);

